import { rulesEngineRequest } from './rulesEngineClient'
import { getRulesEngineTransactionAssistantUrl } from './rulesEngineEndpoints'

const normalizeText = (value) => (typeof value === 'string' ? value.trim() : '')

const getResponsePayload = (responseData) => {
  if (responseData?.status === 'ok' && responseData?.data) {
    return responseData.data
  }

  return responseData
}

const extractResponseText = (responseData) => {
  const payload = getResponsePayload(responseData)

  const directText = normalizeText(
    payload?.answer
    || payload?.response
    || payload?.content
    || payload?.message
    || payload?.output_text
  )

  if (directText) {
    return directText
  }

  if (Array.isArray(payload?.messages)) {
    for (let index = payload.messages.length - 1; index >= 0; index -= 1) {
      const text = normalizeText(payload.messages[index]?.content)
      if (text) {
        return text
      }
    }
  }

  if (Array.isArray(payload?.choices) && payload.choices.length > 0) {
    const choice = payload.choices[0]
    const messageText = normalizeText(choice?.message?.content)
    if (messageText) {
      return messageText
    }

    const text = normalizeText(choice?.text)
    if (text) {
      return text
    }
  }

  return ''
}

// Structured instruction that makes the assistant produce a COAF report body
// following the sections of relatorio_coaf.docx (SISCOAF / COS espelho de dados).
export const COAF_REPORT_PROMPT = [
  'Gere um relatorio de Comunicacao de Operacao Suspeita (COS) ao COAF com base',
  'nos dados desta transacao, do grafo e dos apontamentos fornecidos.',
  'Siga EXATAMENTE esta estrutura, usando os titulos numerados abaixo como',
  'cabecalhos de secao (uma linha cada) e preenchendo com os dados disponiveis',
  '(use "[Nao informado]" quando o dado nao existir):',
  '',
  '1. Dados da Instituicao Comunicante',
  '2. Dados do Envolvido (Pessoa Fisica ou Juridica)',
  '3. Detalhes da Operacao / Ocorrencia',
  '4. Enquadramento Tecnico (Codigos de Ocorrencia)',
  '5. Descricao Detalhada da Ocorrencia',
  '6. Conclusao',
  '',
  'Na secao 5, escreva um relato claro, objetivo e cronologico explicando por que',
  'a operacao e considerada suspeita, citando os apontamentos como evidencia.',
  'A secao 6 deve ser escrita EXCLUSIVAMENTE como lista de bullets iniciados por "- ",',
  'um por linha, cada bullet com uma frase curta e objetiva, cobrindo nesta ordem:',
  'os indicios confirmados, o enquadramento aplicavel, o risco residual e a',
  'recomendacao final (comunicar ou nao comunicar ao COAF). Nao use texto corrido',
  'na secao 6.',
  'Escreva o relatorio COMPLETO: nenhuma secao pode ficar vazia ou interrompida, e',
  'a secao 5 deve ter no minimo 3 paragrafos. Nao resuma nem abrevie.',
  'Use negrito (**texto**) apenas para rotulos de campo e listas com "-" quando houver',
  'varios itens; o restante deve ser texto corrido.',
  'Responda apenas com o conteudo do relatorio, em portugues, sem comentarios extras.',
].join('\n')

export const requestCoafReport = async ({
  operationId,
  transaction,
  graphContext,
  appointmentsContext,
}) => askTransactionAssistant({
  operationId,
  question: COAF_REPORT_PROMPT,
  transaction,
  graphContext,
  appointmentsContext,
  assistantOptions: {
    language: 'pt-BR',
    response_mode: 'structured_report',
    report_template: 'coaf_cos',
    require_evidence: true,
    // The default assistant budget truncates the report mid-section (single page).
    max_output_tokens: 4000,
  },
})

export const askTransactionAssistant = async ({
  operationId,
  question,
  transaction,
  graphContext,
  appointmentsContext,
  assistantOptions,
}) => {
  const response = await rulesEngineRequest({
    method: 'post',
    url: getRulesEngineTransactionAssistantUrl(process.env.REACT_APP_API_RULES_URL),
    data: {
      operation_id: operationId,
      question,
      transaction,
      ...(graphContext ? { graph_context: graphContext } : {}),
      ...(appointmentsContext ? { appointments_context: appointmentsContext } : {}),
      ...(assistantOptions ? { assistant_options: assistantOptions } : {}),
    },
  })

  const responseData = response?.data || {}
  const payload = getResponsePayload(responseData)

  return {
    text: extractResponseText(responseData),
    raw: responseData,
    payload,
  }
}
